import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CoaParameter } from 'src/app/models/coa-parameter';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CoasParameterService } from 'src/app/services/coas-parameter.service';

@Component({
  selector: 'app-coas-parameter',
  templateUrl: './coas-parameter.component.html',
  styleUrls: ['./coas-parameter.component.scss']
})
export class CoasParameterComponent implements OnInit{

  parameterData = {
    parameter: null,
    method: null,
    units: null
  }

  parameters: CoaParameter[] = [];
  creating = false;
  loading = false;
  loadingData = false;
  editing: number = null;
  editItem: CoaParameter = null;
  editItemTemp: CoaParameter = null;
  filterWord: string = "";
  filterParameters: CoaParameter[] = [];

  constructor(
    private coasParameterService: CoasParameterService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.getParameters();
  }

  getParameters(){
    this.loadingData = true;
    this.coasParameterService.getCoasParameters().subscribe({
      next: (response: ResponseObject) => {
        this.parameters = response.data;
        this.filterParameters = response.data;
        this.filter();
        this.loadingData = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener parametros coa","Error" )
        this.loadingData = false;
      }
    });
  }

  filter() {
    this.filterParameters = this.parameters.filter((pr) => {
      return (pr.parameter).toLowerCase().includes(this.filterWord.toLowerCase()) ||
      (pr.method && pr.method.toLowerCase().includes(this.filterWord.toLowerCase())) || 
      pr.units.toLowerCase().includes(this.filterWord.toLowerCase());
    })

    this.filterParameters = this.filterParameters.sort((a, b) =>
      a.parameter.localeCompare(b.parameter)
    );
  }

  createParameter() {
    if (!this.verifyForm) {
      return;
    }

    this.coasParameterService.createParameter(this.parameterData).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Parametro creado.", "Exito");
        this.resetForm();
        this.getParameters();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al crear el parametro coas", "Error");
      }
    });
  }

  deleteParameter(item: CoaParameter) {
    this.coasParameterService.deleteParameter(item.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Parametro COA eliminado.", "Exito");
        this.getParameters();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al eliminar parametro COA", "Error");
      }
    });
  }

  updateParameter(itemId: number){
    let data = {
      parameter: this.editItem.parameter,
      method: this.editItem.method,
      units: this.editItem.units
    }

    this.coasParameterService.updateParameter(data, itemId).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Parametro COA actualizado.", "Exito");
        this.getParameters();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al actualizar parametro COA", "Error");
      }
    });
  }

  initEditing(item: CoaParameter) {
    this.editing = item.id;
    this.editItem = item;
    this.editItemTemp = item;
  }

  get verifyForm() {
    if (this.parameterData.parameter == null || 
      this.parameterData.parameter == "" ||
      // this.parameterData.method == "" ||
      // this.parameterData.method == null ||
      this.parameterData.units == null ||
      this.parameterData.units == ""
    ) {
      return false
    }
    return true;
  }

  resetForm() {
    this.parameterData = {
      parameter: null,
      method: null,
      units: null
    }
  }
}
